<template>

         <div id="page-wrapper">
            <div class="row">
                <div class="col-lg-12">
                    <h1 class="page-header">الرئيسية</h1>
                </div>
                <!-- /.col-lg-12 -->
            </div>
            <!-- /.row -->
            <div v-show="dba || saad" class="row">
              <div class='form-group col-lg-12 col-sm-12'>
                <h4 >الفرع: {{brancheName}}</h4>
                <select  style="padding: 0px" @change="getData()" class="form-control" v-model="branche_id">
                  <option v-for="item in branches" :key="item.id" v-bind:value="item.id">
                    {{ item.name }}
                  </option>
                </select>
              </div>
                <div class="col-lg-3 col-md-6">
                    <div class="panel panel-primary">
                        <div class="panel-heading">
                            <div class="row">
                                <div class="col-xs-4" style="padding: 0px 5px 0px 5px">
                                    <i class="fa fa-comments fa-3x"></i>
                                </div>
                                <div class="col-xs-8 text-center" style="font-size:18px;padding: 0px 5px 0px 5px">
                                    <div>{{panel11}}</div>
                                    <div>أقساط متأخرة</div>
                                </div>
                            </div>
                        </div>
                        <a href="#">
                            <div class="panel-footer">
                                <span class="pull-left">تفاصيل</span>
                                <span class="pull-right">{{panel12}} ج.م</span>
                                <div class="clearfix"></div>
                            </div>
                        </a>
                    </div>
                </div>
                <div class="col-lg-3 col-md-6">
                     <div class="panel panel-green">
                        <div class="panel-heading">
                            <div class="row">
                              <div class="col-xs-4" style="padding: 0px 5px 0px 5px">
                                    <i class="fa fa-comments fa-3x"></i>
                                </div>
                                <div class="col-xs-8 text-center" style="font-size:18px;padding: 0px 5px 0px 5px">
                                  <div>{{panel21}}</div>
                                    <div>مديونية صيانة</div>
                                </div>
                            </div>
                        </div>
                        <a href="#">
                            <div class="panel-footer">
                                <span class="pull-left">تفاصيل</span>
                                <span class="pull-right">{{panel22}} ج.م</span>
                                <div class="clearfix"></div>
                            </div>
                        </a>
                    </div>
                </div>
                <div class="col-lg-3 col-md-6">
                     <div class="panel panel-yellow">
                        <div class="panel-heading">
                            <div class="row">
                              <div class="col-xs-4" style="padding: 0px 5px 0px 5px">
                                    <i class="fa fa-comments fa-3x"></i>
                                </div>
                                <div class="col-xs-8 text-center" style="font-size:18px;padding: 0px 5px 0px 5px">
                                    <div>{{panel31}}</div>
                                    <div>مديونية الأقساط</div>
                                </div>
                            </div>
                        </div>
                        <a href="#">
                            <div class="panel-footer">
                                <span class="pull-left">تفاصيل</span>
                                <span class="pull-right">{{panel32}}ج.م</span>
                                <div class="clearfix"></div>
                            </div>
                        </a>
                    </div>
                </div>
                <div class="col-lg-3 col-md-6">
                     <div class="panel panel-red">
                        <div class="panel-heading">
                            <div class="row">
                              <div class="col-xs-4" style="padding: 0px 5px 0px 5px">
                                    <i class="fa fa-comments fa-3x"></i>
                                </div>
                                <div class="col-xs-8 text-center" style="font-size:18px;padding: 0px 5px 0px 5px">
                                  <div>{{panel41}}</div>
                                    <div>المديونية</div>
                                </div>
                            </div>
                        </div>
                        <a href="#">
                            <div class="panel-footer">
                                <span class="pull-left">تفاصيل</span>
                                <span class="pull-right">{{panel42}}ج.م</span>
                                <div class="clearfix"></div>
                            </div>
                        </a>
                    </div>
                </div>
            </div>
            <!-- /.row -->
            <!-- /.row -->
            <div v-show="dba || saad" class="row">
                <div class="col-lg-3 col-md-6">
                    <div class="panel panel-primary">
                        <div class="panel-heading">
                            <div class="row">
                                <div class="col-xs-4" style="padding: 0px 5px 0px 5px">
                                    <i class="fa fa-comments fa-3x"></i>
                                </div>
                                <div class="col-xs-8 text-center" style="font-size:18px;padding: 0px 5px 0px 5px">
                                    <div>{{panel211}}</div>
                                    <div>أقساط واجبة السداد</div>
                                </div>
                            </div>
                        </div>
                        <a href="#">
                            <div class="panel-footer">
                                <span class="pull-left">تفاصيل</span>
                                <span class="pull-right">{{panel212}} ج.م</span>
                                <div class="clearfix"></div>
                            </div>
                        </a>
                    </div>
                </div>
                <div class="col-lg-3 col-md-6">
                     <div class="panel panel-green">
                        <div class="panel-heading">
                            <div class="row">
                              <div class="col-xs-4" style="padding: 0px 5px 0px 5px">
                                    <i class="fa fa-comments fa-3x"></i>
                                </div>
                                <div class="col-xs-8 text-center" style="font-size:18px;padding: 0px 5px 0px 5px">
                                  <div>{{panel221}}</div>
                                    <div>أقساط مسددة بالكامل</div>
                                </div>
                            </div>
                        </div>
                        <a href="#">
                            <div class="panel-footer">
                                <span class="pull-left">تفاصيل</span>
                                <span class="pull-right">{{panel222}} ج.م</span>
                                <div class="clearfix"></div>
                            </div>
                        </a>
                    </div>
                </div>
                <div class="col-lg-3 col-md-6">
                     <div class="panel panel-yellow">
                        <div class="panel-heading">
                            <div class="row">
                              <div class="col-xs-4" style="padding: 0px 5px 0px 5px">
                                    <i class="fa fa-comments fa-3x"></i>
                                </div>
                                <div class="col-xs-8 text-center" style="font-size:18px;padding: 0px 5px 0px 5px">
                                    <div>{{panel231}}</div>
                                    <div>أقساط غير مسددة</div>
                                </div>
                            </div>
                        </div>
                        <a href="#">
                            <div class="panel-footer">
                                <span class="pull-left">تفاصيل</span>
                                <span class="pull-right">{{panel232}}ج.م</span>
                                <div class="clearfix"></div>
                            </div>
                        </a>
                    </div>
                </div>
                <div class="col-lg-3 col-md-6">
                     <div class="panel panel-red">
                        <div class="panel-heading">
                            <div class="row">
                              <div class="col-xs-4" style="padding: 0px 5px 0px 5px">
                                    <i class="fa fa-comments fa-3x"></i>
                                </div>
                                <div class="col-xs-8 text-center" style="font-size:18px;padding: 0px 5px 0px 5px">
                                  <div>{{panel241}}</div>
                                    <div>أقساط مسددة جزئيا</div>
                                </div>
                            </div>
                        </div>
                        <a href="#">
                            <div class="panel-footer">
                                <span class="pull-left">تفاصيل</span>
                                <span class="pull-right">{{panel242}}ج.م</span>
                                <div class="clearfix"></div>
                            </div>
                        </a>
                    </div>
                </div>
            </div>
            <!-- /.row -->
            <div v-show="dba || saad" class="row">
              <div class='panel panel-default'>
                  <div class='panel-heading'>
                    <i class="fa fa-clock-o fa-fw"></i>
                    هنا يتم عرض مخطط الفروع
                    </div>
                  <!-- /.panel-heading -->
                  <div class='panel-body'>
                    <table width='100%' class='table table-striped table-bordered table-hover' id='dataTables-example'>
                        <thead>
                          <tr>

                              <th style='text-align: center'>م</th>
                              <th style='text-align: center'>الفرع</th>
                              <th style='text-align: center'>الخطوط</th>
                              <th style='text-align: center'>المناطق</th>
                              <th style='text-align: center'>التعاقدات</th>
                              <th style='text-align: center'>الموظفين</th>
                              <th style='text-align: center'>فنى</th>
                              <th style='text-align: center'>محصل</th>
                              <th style='text-align: center'>مفوض</th>
                          </tr>
                        </thead>
                        <tbody>
                            <tr class='odd gradeX' v-for='(record,index) in data1' :key='record.id'>

                              <td align='center'>{{index + 1}}</td>
                              <td align='center'>{{record.name}}</td>
                              <td align='center'>{{record.itineraries}}</td>
                              <td align='center'>{{record.regions}}</td>
                              <td align='center'>{{record.contracts}}</td>
                              <td align='center'>{{record.users}}</td>
                              <td align='center'>{{record.technicals}}</td>
                              <td align='center'>{{record.collectors}}</td>
                              <td align='center'>{{record.delegates}}</td>
                            </tr>
                        </tbody>
                    </table>                      <!-- /.table-responsive -->
                  </div>
                  <!-- /.panel-body -->
              </div>
            </div>
            <div v-show="dba || saad" class="row">
                <!-- /.col-lg-8 -->
                <div class="col-lg-4">
                    <!-- /.panel -->
                    <div class="panel panel-default">
                        <div class="panel-heading">
                            <i class="fa fa-bar-chart-o fa-fw"></i> تقرير الخزن
                        </div>
                        <div class="panel-body">
                          <div class='col-lg-6 col-md-6 col-sm-6' style="padding: 5px">
                            <tbDate :today='today' :mytitle='fromDateTitle' v-model= 'fromDate' ></tbDate>
                          </div>
                          <div class='col-lg-6 col-md-6 col-sm-6' style="padding: 5px">
                            <tbDate :today='today' :mytitle='tomDateTitle' v-model= 'toDate' ></tbDate>
                          </div>
                          <div class='col-lg-6 col-md-6 col-sm-6' style="padding: 5px">
                            <label>الفرع</label>
                            <select class="form-control" style="padding: 0px" v-model="treasuryBranch_id">
                              <option v-for="item in branches" v-bind:key="item.id" v-bind:value="item.id">
                                {{ item.name }}
                              </option>
                            </select>
                          </div>
                          <div class='col-lg-6 col-md-6 col-sm-6' style="padding-top: 25px">
                            <button @click='treasuryReport()' type='button' class='btn btn-success btn-block'>عرض</button>
                          </div>
                            <table class='table  table-bordered ' >
                              <thead>
                                <tr>
                                  <th style='vertical-align: middle;padding:2px;text-align: center'>م</th>
                                  <th style='vertical-align: middle;padding:2px;text-align: center'>بيان</th>
                                  <th style='vertical-align: middle;padding:2px;text-align: center'>المبلغ</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr  v-for='(record, index) in treasuryRec' :key='index' >
                                  <td style="padding:2px" align='center'>{{index + 1}}</td>
                                  <td style="padding:2px" align='center'>{{record.type}}</td>
                                  <td style="padding:2px" align='center'>{{record.amount}}</td>
                                </tr>
                              </tbody>
                            </table>
                        </div>
                        <!-- /.panel-body -->
                    </div>
                </div>
                <!-- /.col-lg-4 -->
            </div>
            <!-- /.row -->
        </div>
        <!-- /#page-wrapper -->

</template>
<script>
import axios from 'axios'
import tbDate from '@/components/myComponents/tbDate'
export default {
  components: {
    tbDate
  },
  name: 'DashBoard',
  data () {
    return {
      emptyRec: [{id: 0, name: 'الكل'}],
      treasuryRec: '',
      treasuryBranch_id: '',
      today: true,
      fromDateTitle: 'من',
      fromDate: '',
      tomDateTitle: 'الى',
      toDate: '',
      brancheName: '',
      branches: [],
      branche_id: '',
      dba: false,
      saad: false,
      isLoading: false,
      panel11: '',
      panel12: '',
      panel21: '',
      panel22: '',
      panel31: '',
      panel32: '',
      panel41: '',
      panel42: '',
      panel211: '',
      panel212: '',
      panel221: '',
      panel222: '',
      panel231: '',
      panel232: '',
      panel241: '',
      panel242: '',
      data1: {}
    }
  },
  created () {
    if (localStorage.getItem('user_id') === '2') {
      this.dba = true
      this.branches = JSON.parse(localStorage.getItem('Branches'))
    }
    if (localStorage.getItem('user_id') === '3') {
      this.saad = true
      this.branches = JSON.parse(localStorage.getItem('Branches'))
    }
    this.branche_id = localStorage.getItem('BrancheID')
    let i = this.branches.findIndex(x => x.id === parseInt(this.branche_id))
    if (i > -1) {
      this.treasuryBranch_id = this.branches[i].treasuries
    }
    this.getData()
  },
  methods: {
    getData () {
      this.isLoading = true
      axios.post(this.$apiURL + 'getDashboradData', {
        token: localStorage.getItem('token'),
        branche_id: this.branche_id
      })
        .then(res => {
          this.brancheName = res.data.name
          this.panel11 = res.data.ReturnValue_02[0].count
          this.panel12 = res.data.ReturnValue_02[0].total
          this.panel21 = '----'
          this.panel22 = res.data.ReturnValue_02[1].total

          this.panel31 = res.data.ReturnValue_02[2].count
          this.panel32 = res.data.ReturnValue_02[2].total

          this.panel41 = '----'
          this.panel42 = parseInt(res.data.ReturnValue_02[1].total) + parseInt(res.data.ReturnValue_01[2].total)

          this.panel211 = res.data.ReturnValue_01[0].rec_count
          this.panel212 = res.data.ReturnValue_01[0].total
          this.panel221 = res.data.ReturnValue_01[1].rec_count
          this.panel222 = res.data.ReturnValue_01[1].total
          this.panel231 = res.data.ReturnValue_01[2].rec_count
          this.panel232 = res.data.ReturnValue_01[2].total
          this.panel241 = res.data.ReturnValue_01[3].rec_count
          this.panel242 = res.data.ReturnValue_01[3].total
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.push('login')
          }
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          this.isLoading = false
        })
    },
    // ========================================
    treasuryReport () {
      this.isLoading = true
      axios.post(this.$apiURL + 'get-treasury-report', {
        token: localStorage.getItem('token'),
        from: this.fromDate,
        to: this.toDate,
        branch_id: this.treasuryBranch_id
      })
        .then(res => {
          this.treasuryRec = res.data
          var total = 0
          var newRec = []
          for (let i in res.data) { total += res.data[i].amount }
          newRec[newRec.length] = {}
          newRec[newRec.length - 1].type = 'الاجمالى'
          newRec[newRec.length - 1].amount = total
          this.treasuryRec.push(newRec[0])
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.push('login')
          }
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          this.isLoading = false
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/DashBoard.vue